(function() {
  let wistiaVideoBlock = document.querySelector('.wistia_responsive_padding');

  var videoUploaded = true;
  var translationStarted = false;
  var textJson = false;
  var startFrom = 0;
  var translateText;
  var currentLang = $('html').attr('lang');
  var translateTo = 'russian';
  if(currentLang == 'uk') translateTo = 'ukrainian';
  else translateTo = 'english';

  
  /* Lessons navigation */
  
  $('.lessons-nav select').on('change', function() {
    let url = $(this).val();
    if(url) {
      videoUploaded= false;
      wistiaVideoBlock.dataset.handle = url;
      prevNextLessonButtons($(this), $(this).find('option:selected'));
      getJsonTranslation();
    }
  });
  $('.lessons-nav .nav-link').on('click', function() {
    if($(this).hasClass('disabled')) return;
    let lessonsSelect = $(this).siblings('select');
    let indexCount = 1;
    if($(this).hasClass('prev-lesson')) indexCount = -1;
    let optionSelectedIndex = lessonsSelect.find('option:selected');
    let optionNewIndex = optionSelectedIndex.index() + indexCount;
    let optionNew = lessonsSelect.find('option:nth-child('+ (optionNewIndex + 1) +')');
    if(optionNew.length) {
      lessonsSelect.val(optionNew.val()).change();
      prevNextLessonButtons(lessonsSelect, optionNew);
    }
  });
  function prevNextLessonButtons(lessonsSelect, option) {
    let cuurentIndex = option.index();
    let lastChildIndex = lessonsSelect.find('option:last-child').index() - 1;
    let prevButton = lessonsSelect.siblings('.prev-lesson');
    let nextButton = lessonsSelect.siblings('.next-lesson');
    prevButton.removeClass('disabled');
    nextButton.removeClass('disabled');
    if(cuurentIndex == 1) prevButton.addClass('disabled');
    if(cuurentIndex == lastChildIndex) nextButton.addClass('disabled');
  }
  

  getJsonTranslation();

  
  function getJsonTranslation() {
  		
    let articleHandle = wistiaVideoBlock?.dataset?.handle;
    if (articleHandle) {
    	if(~articleHandle.indexOf('://')) {
    	  articleHandle = articleHandle.replace('https://academy.shopify.com/', '');
          articleHandle = articleHandle.replace('https://www.shopify.com/learn/course/', '');
          articleHandle = articleHandle.replace('https://www.shopify.com/learn/tutorials/', '');
        }
        if(~articleHandle.indexOf('/')) {
    	  articleHandle = articleHandle.split('/')[0] + '|||' + articleHandle.split('/')[1];
    	}
    	fetch('https://insales-api.info/shopify-courses/index.php?handle=' + articleHandle)
    	  .then((response) => {
    		return response.json();
    	  })
    	  .then((data) => {
    	//	  console.log('translateTo = '+translateTo);

    		if(data?.error == 'yes') {
    	  //  console.log('translation not found for '+articleHandle);
    		  clearInterval(translateText);
    		  backEnglishText();
    		}
    		else if(data && data[translateTo] && data?.english) {
              if(!videoUploaded) {
                videoUploaded = true;
                wistiaId = data['iframe_url'];
                console.log('wistiaId = '+wistiaId);
                if(wistiaId) changeVideo(articleHandle, wistiaId)
              }
    	//	  console.log('have translation for '+articleHandle);
    		  textJson = data;
    		  hideEnglishPhrases();
    	//	  console.log('interval');
    		  clearInterval(translateText);
    		  translateText = setInterval(function(){
    			pasteTrans();
    		  }, 300);
    		}
    		else {
    	//	  console.log('not found translation');
    		  clearInterval(translateText);
    		  backEnglishText();
    		}
    	  }).catch((error) => {
    		  console.log(error);
    	  });
      }
  }
		
		
  function pasteTrans() {
	$(wistiaVideoBlock).find('.w-captions .w-captions-line').each(function() {
		let _this = this;
		let text = $(_this).find('span').text().trim();
		if (!~text.indexOf('|||')) {
			phraseTrans = getTranslation(text);
     	    //console.log('phraseTrans = '+phraseTrans);
			if (!phraseTrans) {
				phraseTrans = text;
				console.log('not found: "' + phraseTrans + '"');
			}
			if ($(_this).index() == 1 && $(_this).siblings('.w-captions-line').find('span').attr('data-after') == phraseTrans) {
				$(_this).hide();
			} else {
				$(_this).find('span').attr('data-after', phraseTrans);
				$(_this).show();
			}
			$(_this).find('span').text(text+'|||');
			/*
	  $.ajax({
		  url: 'https://translation.googleapis.com/language/translate/v2?key=AIzaSyDtY5VkHBXHcZOqkzu9oV2OVwmG4tXmI9s&q='+text+'&source=en&target=ru&format=text',
	  }).always(function(data) {
		  console.log('data', data.data.translations);
		  if(data?.data?.translations[0]?.translatedText) {
		//	  console.log('data?.translation?.translatedText = '+data?.translation?.translatedText);
			$(_this).find('span').attr('data-after', data?.data?.translations[0]?.translatedText);
		  }
	  });
	  */
		}
		$(_this).find('span').text().trim().replace('|||', '');
	});
  }


  function getTranslation(phrase) {
    
    let foundPhrase = false;
    
    if (!phrase || !textJson || !textJson.english || !textJson[translateTo]) return;
    let foundNum = false;
    for (let i = startFrom; i <= Object.keys(textJson.english).length; i++) {
        if (textJson.english[i] == phrase) {
            startFrom = i - 1;
            foundNum = i;
            break;
        }
    }
    if(foundNum === false) {
        for (let i = 0; i <= startFrom; i++) {
            if (textJson.english[i] == phrase) {
                startFrom = i - 1;
                foundNum = i;
                break;
            }
        }
    }
    
    if(foundNum === false) foundPhrase = '-------------';
    if(textJson[translateTo][foundNum]) foundPhrase = textJson[translateTo][foundNum];
    else {
        for (let i = foundNum; i <= Object.keys(textJson.english).length; i++) {
            if(textJson[translateTo][i]) {
                foundPhrase = textJson[translateTo][i];
                break;
            }
        }
    }
    //console.log('foundPhrase = '+foundPhrase);
    return foundPhrase;
  }
	
	
  function hideEnglishPhrases() {
    var css = '.wistia_embed .w-captions .w-captions-line { line-height: 0 !important; } .wistia_embed .w-captions .w-captions-line:nth-child(2) {display: none !important;} .wistia_embed .w-captions .w-captions-line span { font-size: 0 !important; line-height: normal !important; overflow: visible !important; padding: 0 !important; background-color: transparent !important; } .wistia_embed .w-captions .w-captions-line > div > div {display: none !important;} .wistia_embed .w-captions .w-captions-line span:not([data-after]) {display: none !important;} .wistia_embed .w-captions .w-captions-line span:after { content: attr(data-after); font-size: 18px; display: block; padding: 0.25em 0.6em; background: rgba(0, 0, 0, 0.7); color: rgb(255, 255, 255); }',
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');
    
    head.appendChild(style);
    style.type = 'text/css';
    style.id = 'custom-style-english-phrases-hide';
    
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
  }
	
	
  function backEnglishText() {
    document?.querySelector('#custom-style-english-phrases-hide')?.remove();
  }


  function changeVideo(videoUrl, wistiaId) {
    let currentVideo = $('article .top-image .wistia_responsive_padding');
    let wistiaDivEl = '<div class="wistia_responsive_padding waiting"' +
                           'data-handle="'+videoUrl+'"' +
                           'data-video-id="'+wistiaId+'">' +
                        '<div class="wistia_responsive_wrapper">' +
                          '<div class="wistia_embed wistia_async_'+wistiaId+'"></div>' +
                        '</div>' +
                      '</div>';
    currentVideo.after($(wistiaDivEl));
    currentVideo.remove();
    wistiaVideoBlock = document.querySelector('.wistia_responsive_padding.waiting');
    $(wistiaVideoBlock).find('.wistia_embed').addClass('hide-it');
    $(wistiaVideoBlock).trigger('click');
  }
  
})();